import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../global-service.service';
import { RouterModule, Routes, Router } from '@angular/router';
import { Md5} from 'ts-md5/dist/md5';
import { TokenStoreService } from '../auth/token-store.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['../css/pasura.css'],
    standalone: false
})
export class LoginComponent implements OnInit {

  constructor(public globserv: GlobalService,  private router: Router, private tokenStore: TokenStoreService )
  {
  }

  ngOnInit(): void 
  {
  		
  }
  
  doLogin()
  {
  		 var loginResult;
  		 
		 this.globserv.Login.PasswortMD5=Md5.hashAsciiStr(this.globserv.Login.Passwort).toString();
		 
		 var data={	"Login":Object.assign({}, this.globserv.Login)};
		 data.Login.Passwort="";
		 
		 this.globserv.getBackendData("/v1/LoginPasura",data).subscribe (
		 
		 result => 
		  					loginResult = result,
		  					
		  					 err => {
		  					 				console.log("Error");
		  					 				console.log(err);
		  					 		  },
		       () => {
		       		//console.log(JSON.stringify(loginResult));
		       		this.globserv.Login.Passwort="";
				       	if(loginResult.Login.LoginStatus)
			       	{
			       		this.globserv.Login=loginResult.Login;
							
				       	this.tokenStore.setJwtToken(loginResult.Login.JWT);
				       	this.tokenStore.setRefreshToken(loginResult.Login.RefreshToken);
				       	
			       		this.globserv.setPasuraAction('loginOK');
			       		this.globserv.getTarife();
			       		this.globserv.loadSalutation();
			       		this.globserv.serverLog("ClientVersion -> " + this.globserv.ClientVersionText + " / " +this.globserv.Login.LoginName );
			       		
			       		if(loginResult.Login.PasswortAendern)
			       		{
							this.router.navigate(['/benutzer']);			       				
			       			this.globserv.setPasuraAction({"msg":{"title":"Passwort", "typ":"warning","txt":"Bitte Passwort ändern!"}});
			       				
			       		}else{
			       		
			       			this.router.navigate(['/pasura']);
			       		}	
			       	}
		       }
		       
		  ); 
  }
}
